<template lang="pug">
  div
    div.py-1.px-4.basic200.s2.primary400--text {{ credit.group }}
    credit-history-item-details(v-for="(item, itemIndex) in credit.items" :key="item.ref" :item="item" :index="itemIndex" :totalItems="credit.items.length" @selected="$emit('selected', $event)")
</template>

<script>
import CreditHistoryItemDetails from '@/components/settings/bills/CreditHistoryItemDetails.vue'

export default {
  name: 'CreditHistoryItem',
  components: {
    CreditHistoryItemDetails
  },
  props: {
    credit: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
</style>